import {HeroBlock} from "@/pages/common/Home/components/HeroBlock";
import {HeroTitle} from "@/pages/common/Home/components/HeroTitle";

import comprehensive_hover from "@images/home/features/comprehensive-hover.svg";
import comprehensive from "@images/home/features/comprehensive.svg";
import hotline_hover from "@images/home/features/hotline-hover.svg";
import hotline from "@images/home/features/hotline.svg";
import implementation_hover from "@images/home/features/implementation-hover.svg";
import implementation from "@images/home/features/implementation.svg";
import integrating_hover from "@images/home/features/integrating-hover.svg";
import integrating from "@images/home/features/integrating.svg";
import language_hover from "@images/home/features/language-hover.svg";
import language from "@images/home/features/language.svg";
import processing_hover from "@images/home/features/processing-hover.svg";
import processing from "@images/home/features/processing.svg";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const Intro = () => {
  const {t} = useTranslation();

  const cardList = [
    {
      id: 0,
      icon: comprehensive,
      iconHover: comprehensive_hover,
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.card.title_1"),
          }}
        />
      ),
    },
    {
      id: 1,
      icon: integrating,
      iconHover: integrating_hover,
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.card.title_2"),
          }}
        />
      ),
    },
    {
      id: 2,
      icon: language,
      iconHover: language_hover,
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.card.title_3"),
          }}
        />
      ),
    },
    {
      id: 3,
      icon: processing,
      iconHover: processing_hover,
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.card.title_4"),
          }}
        />
      ),
    },
    {
      id: 4,
      icon: implementation,
      iconHover: implementation_hover,
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.card.title_5"),
          }}
        />
      ),
    },
    {
      id: 5,
      icon: hotline,
      iconHover: hotline_hover,
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.card.title_6"),
          }}
        />
      ),
    },
  ];

  return (
    <div className={styles.intro}>
      <HeroTitle>
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.intro_title"),
          }}
        />

        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.intro_desc"),
          }}
        />
      </HeroTitle>

      <div className={"container-home"}>
        <HeroBlock
          cardsTitle={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.features.init_setup.title"),
              }}
            />
          }
          cards={cardList}
          itemHover={"linear-gradient(135deg, #8692CB 0%, #B262C9 100%)"}
          description={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.features.init_setup.desc"),
              }}
            />
          }
        />
      </div>
    </div>
  );
};
